// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"292":"d7a66e39a50acd53556d","928":"0e2f75f1fff05638ab8f"}[chunkId] + ".js";
};